export default __webpack_public_path__ + "static/media/M2HairSalon-3.059f4716.jpg";